
export default {
    name: 'SvgXMark',
    props: {
        color: {
            type: String,
            default: '#FFF',
        },
    },
};
